module.exports = __webpack_public_path__ + "static/media/brand-refresh-map-light.fb590b70.svg";